import { useFormik, FormikHelpers, FormikValues } from "formik";
import * as Yup from "yup";

import { CompanyFormFields } from "../../../../../api/graphql/workplaces";
import { RESOURCE_STRINGS as f } from "../../../../../lib/utils/constants";

const CompanySchema = Yup.object().shape({
  name: Yup.string().min(2, f.validName).required(f.required),
});

interface UseCompanyFormOptions {
  initialValues?: CompanyFormFields;
  enableReinitialize?: boolean;
  onSubmit: (
    values: FormikValues,
    formikHelpers: FormikHelpers<CompanyFormFields>
  ) => Promise<any>;
}

export type CompanyFormik = ReturnType<typeof useCompanyFormik>;

export const useCompanyFormik = (opts: UseCompanyFormOptions) => {
  return useFormik<CompanyFormFields>({
    initialValues: {
      name: "",
      description: "",
      tags: [],
    },
    validateOnBlur: true,
    validateOnChange: true,
    validationSchema: CompanySchema,
    ...opts,
    onSubmit: async (values, formikHelpers) => {
      await opts.onSubmit(values, formikHelpers);
    },
  });
};
